<template>
  <v-card>
    <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
      <v-toolbar-title class="headline grey-text">Edit Income</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.native="updateEditedIncome($v.editIncome)">
        <v-icon color="green">fas fa-check</v-icon>
      </v-btn>
      <v-btn icon @click.native="$router.push({ path: '/dashboard/income' })">
        <v-icon color="red">fas fa-times</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text style="padding-top: 0;">
      <v-container grid-list-md v-bind:class="{'padContent': !drawer}">
        <v-layout wrap>
          <v-flex x12>
            <v-autocomplete v-bind:items="curriencies"
                            v-model="editIncome.currency"
                            label="Currency"
                            chips
                            :error-messages="currencyErrors"
                            @input="$v.editIncome.currency.$touch(), adjustCurrency()"
                            @blur="$v.editIncome.currency.$touch()"></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Income Name" v-model="editIncome.incomeName"
                          :error-messages="incomeNameErrors"
                          @input="$v.editIncome.incomeName.$touch()"
                          @blur="$v.editIncome.incomeName.$touch()"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete v-bind:items="account"
                            v-model="editIncome.account"
                            label="Account"
                            chips
                            prepend-icon="fa-balance-scale"
                            hint="What Account does this belong to?"
                            persistent-hint
                            :error-messages="accountErrors"
                            @input="$v.editIncome.account.$touch()"
                            @blur="$v.editIncome.account.$touch()"></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete v-bind:items="category"
                            v-model="editIncome.category"
                            label="Category"
                            chips
                            prepend-icon="fa-tag"
                            hint="What Category does this belong to?"
                            persistent-hint
                            :error-messages="categoryErrors"
                            @input="$v.editIncome.category.$touch()"
                            @blur="$v.editIncome.category.$touch()"></v-autocomplete>
          </v-flex>
          <v-flex xs12 v-if="conversion">
            <v-text-field label="Currency Conversion"
                          prepend-icon="fas fa-balance-scale"
                          v-model="editIncome.currencyConversion.conversionRate"
                          @click.prevent="getCurrencyConvertionRate()"
                          @focus="getCurrencyConvertionRate()"
                          :error-messages="currencyConversionErrors"
                          @input="$v.editIncome.currencyConversion.$touch()"
                          @blur="$v.editIncome.currencyConversion.$touch()"></v-text-field>
            <CurrencyConverter ref="converter" v-on:conversionRate="setCurrencyConversionRate($event)"></CurrencyConverter>
          </v-flex>
          <v-flex xs12 v-if="conversion">
            <v-text-field label="Amount" prepend-icon="fas fa-money-bill" type="number" min="1"
                          v-model="editIncome.foreignCurrencyAmount"
                          :error-messages="foreignCurrencyAmountErrors"
                          @input="$v.editIncome.foreignCurrencyAmount.$touch(), calculateConvertedAmount()"
                          @blur="$v.editIncome.foreignCurrencyAmount.$touch()"></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="!conversion">
            <v-text-field label="Income Amount" prepend-icon="fa-money-bill-alt" type="number" min="1"
                          v-model="editIncome.incomeAmount"
                          :error-messages="incomeAmountErrors"
                          @input="$v.editIncome.incomeAmount.$touch()"
                          @blur="$v.editIncome.incomeAmount.$touch()"></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="conversion">
            <v-text-field label="Converted Amount" prepend-icon="fa-money-bill-alt"
                          v-model="editIncome.incomeAmount"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Comment" prepend-icon="fa-comment" v-model="editIncome.comment"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-switch v-model="recurringIncome"
                      label="Recurring Income"></v-switch>
          </v-flex>
          <v-flex xs6 v-if="!recurringIncome">
            <v-dialog ref="dialog"
                      persistent
                      lazy
                      v-model="editModelIncomeDate"
                      full-width
                      width="290px"
                      :return-value.sync="editIncome.incomeDate">
              <v-text-field slot="activator"
                            label="Income Date"
                            v-model="editIncome.incomeDate"
                            prepend-icon="event"
                            :error-messages="incomeDateErrors"
                            @input="$v.editIncome.incomeDate.$touch()"
                            @blur="$v.editIncome.incomeDate.$touch()"
                            readonly></v-text-field>
              <v-date-picker v-model="editIncome.incomeDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="editModelIncomeDate = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog.save(editIncome.incomeDate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6 v-if="!recurringIncome">
            <v-dialog ref="timemenu"
                      persistent
                      v-model="timemenuvisibilty"
                      lazy
                      full-width
                      width="290px"
                      :return-value.sync="editIncome.incomeTime">
              <v-text-field slot="activator"
                            label="Time Picker"
                            v-model="editIncome.incomeTime"
                            prepend-icon="access_time"
                            readonly></v-text-field>
              <v-time-picker v-model="editIncome.incomeTime" actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="timemenuvisibilty = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.timemenu.save(editIncome.incomeTime)">OK</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs12 v-if="recurringIncome">
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field label="Repeat Every" type="number" min="1" max="60" v-model="editIncome.repeat"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select v-model="editIncome.cycle"
                          :items="['Day','Week','Month','Year']"></v-select>
              </v-flex>
            </v-layout>
            <v-radio-group v-model="editIncome.period" row>
              <v-radio label="Forever" value="Forever"></v-radio>
              <v-radio label="For Number of cycles" value="For"></v-radio>
            </v-radio-group>
            <v-text-field v-if="editIncome.period === 'For'" label="Number of cycles" type="number" min="1" max="60" v-model="editIncome.numberOfCycles"></v-text-field>
            <v-dialog ref="goesOff"
                      persistent
                      lazy
                      v-model="editModelGoesOff"
                      full-width
                      width="290px"
                      :return-value.sync="editIncome.goesOffFirst">
              <v-text-field slot="activator"
                            label="Start Date"
                            v-model="editIncome.goesOffFirst"
                            prepend-icon="event"
                            readonly></v-text-field>
              <v-date-picker v-model="editIncome.goesOffFirst" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="editModelGoesOff = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.goesOff.save(editIncome.goesOffFirst)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-container>

    </v-card-text>

  </v-card>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minValue } from 'vuelidate/lib/validators'
  
  import { globalFunctions } from '../../javascript/globalFunctions'
  import { accountManager } from '../../javascript/accountManager'
  import { incomeManager } from '../../javascript/incomeManager'

  import currencyConverter from '../../components/reuseable/currencyConverter/currencyConverter.vue'

  export default {
    mixins: [validationMixin],
    components: {
      'CurrencyConverter': currencyConverter
    },
    props: ['drawer'],
    data() {
      return {
        account: [],
        category: ["cat"],
        curriencies: ["USD", "JMD"],
        editModelIncomeDate: false,
        editModelGoesOff: false,
        sameIncome: false,
        conversion: false,
        recurringIncome: false,
        timemenuvisibilty: false,
        editIncome: {
          id: 0,
          incomeName: '',
          account: '',
          incomeType: '',
          foreignCurrencyAmount: 0,
          incomeAmount: 0,
          currencyConversion: {},
          currency: '',
          incomeDate: '',
          incomeTime: '',
          comment: '',
          category: '',

          //Recurring
          repeat: 1,
          cycle: '',
          period: '',
          numberOfCycles: 1,
          goesOffFirst: '',

          //State of Current Object
          objectState: 'New'
        },
        items: []
      }
    },
    computed: {
      incomeNameErrors() {
        const errors = []
        if (!this.$v.editIncome.incomeName.$dirty && !this.$v.editIncome.incomeName.$dirty) return errors
        this.sameIncome && errors.push('A Income already has this Name. Enter a new Name of update Income')
        !this.$v.editIncome.incomeName.required && !this.$v.editIncome.incomeName.required && errors.push('Income Name is required')
        return errors
      },
      accountErrors() {
        const errors = []
        if (!this.$v.editIncome.account.$dirty && !this.$v.editIncome.account.$dirty) return errors
        !this.$v.editIncome.account.required && !this.$v.editIncome.account.required && errors.push('Account is required')
        return errors
      },
      currencyErrors() {
        const errors = []
        if (!this.$v.editIncome.currency.$dirty) return errors
        !this.$v.editIncome.currency.required && errors.push('Currency is required')
        return errors
      },
      currencyConversionErrors() {
        const errors = []
        if (!this.$v.editIncome.currencyConversion.$dirty) return errors
        !this.$v.editIncome.currencyConversion.required && errors.push('Currency Conversion is required')
        return errors
      },
      categoryErrors() {
        const errors = []
        if (!this.$v.editIncome.category.$dirty && !this.$v.editIncome.category.$dirty) return errors
        !this.$v.editIncome.category.required && !this.$v.editIncome.category.required && errors.push('Category is required')
        return errors
      },
      foreignCurrencyAmountErrors() {
        const errors = []
        if (!this.$v.editIncome.foreignCurrencyAmount.$dirty && !this.$v.editIncome.foreignCurrencyAmount.$dirty) return errors
        !this.$v.editIncome.foreignCurrencyAmount.minValue && !this.$v.editIncome.foreignCurrencyAmount.minValue && errors.push('Amount must be at least 1')
        return errors
      },
      incomeAmountErrors() {
        const errors = []
        if (!this.$v.editIncome.incomeAmount.$dirty && !this.$v.editIncome.incomeAmount.$dirty) return errors
        !this.$v.editIncome.incomeAmount.minValue && !this.$v.editIncome.incomeAmount.minValue && errors.push('Income Amount must be at least 1')
        return errors
      },
      incomeDateErrors() {
        const errors = []
        if (!this.$v.editIncome.incomeDate.$dirty) return errors
        !this.$v.editIncome.incomeDate && errors.push('Income Date is required')
        return errors
      },
    },
    methods: {
      adjustCurrency: function () {
        if (this.editIncome.account !== '') {
          let acc = accountManager.getAccountByName(this.editIncome.account)

          if (this.editIncome.currency === '') {
            this.editIncome.currency = acc.accountCurrency
          }
          else if (this.editIncome.currency !== acc.accountCurrency) {
            this.conversion = true
          }
          else if (this.editIncome.currency === acc.accountCurrency) {
            this.conversion = false
          }
        }
      },
      getCurrencyConvertionRate: function () {
        this.$refs.converter.showConverter()

        let acc = accountManager.getAccountByName(this.editIncome.account)

        this.$refs.converter.getcurrencyData(this.editIncome.currency, acc.accountCurrency)
      },
      setCurrencyConversionRate: function (data) {
        this.editIncome.currencyConversion = data
      },
      incomeCheck: function ($v) {
        $v.$touch(); //Triggers Error Messages

        if (this.editIncome.incomeAmount <= 0 || !globalFunctions.isIntOrFloat(this.editIncome.incomeAmount) || this.editIncome.incomeAmount === "") { this.editIncome.incomeAmount = 0 }

        if ($v.incomeName.$invalid || $v.category.$invalid || $v.account.$invalid) {
          return false
        }

        if (this.recurringIncome) {
          this.editIncome.incomeType = "Recurring"
        } else if (!this.recurringIncome) {
          this.editIncome.incomeType = "OneTime"
        }

        //for (let i = 0; i < this.items.length; i++) {
        //  if (this.items[i].incomeName.toLowerCase() === this.editIncome.incomeName.toLowerCase()) {
        //    this.sameIncome = true
        //    return false
        //  }
        //  if (i === this.items.length - 1) {
        //    this.sameIncome = false
        //  }
        //}

        return true
      },
      updateEditedIncome: function ($v) {
        if (this.incomeCheck($v)) {

          this.editIncome.objectState = "Update"

          this.$store.commit('updateIncomeinStore', this.editIncome)

          incomeManager.updateTransactionFromIncome(this.editIncome)

          this.$router.push({ path: '/dashboard/income' })
        }
      },
      editIncomeSetter: function (item) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id === parseInt(item)) {
            let editEntry = JSON.parse(JSON.stringify(this.items[i]))
            this.editIncome = editEntry
            break
          }
        }
        
      },
      setRecurrringSwitch: function () {
        if (this.editIncome.incomeType === 'Recurring') {
          this.recurringIncome = true
        } else {
          this.recurringIncome = false
        }
      },
      calculateConvertedAmount: function () {
        if (this.editIncome.foreignCurrencyAmount !== 0 && this.editIncome.foreignCurrencyAmount !== '' && this.editIncome.currencyConversion.conversionRate.conversionRate !== '') {
          this.editIncome.incomeAmount = parseFloat(this.editIncome.foreignCurrencyAmount) * parseFloat(this.editIncome.currencyConversion.conversionRate.conversionRate)
        }
        else {
          this.editIncome.incomeAmount = 0
        }
      }
    },
    watch: {
      "editIncome.currencyConversion": function () {
        this.calculateConvertedAmount()
      }
    },
    beforeMount() {
      this.items = this.$store.state.Incomes

      let cat = this.$store.state.Categories
      for (let i = 0; i < cat.length; i++) {
        this.category.push(cat[i].categoryName)
      }

      let acc = this.$store.state.Accounts
      for (let i = 0; i < acc.length; i++) {
        this.account.push(acc[i].accountName)
      }

      this.editIncomeSetter(this.$route.params.itemId)
      this.setRecurrringSwitch()
      this.adjustCurrency()
    },
    validations: {
      editIncome: {
        incomeName: {
          required
        },
        account: {
          required
        },
        currency: {
          required
        },
        currencyConversion: {
          required
        },
        category: {
          required
        },
        foreignCurrencyAmount: {
          required,
          minValue: minValue(1)
        },
        incomeAmount: {
          required,
          minValue: minValue(1)
        },
        incomeDate: {
          required
        }
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/income/EditIncomes.vue